// extracted by mini-css-extract-plugin
export var dataCell = "_lc-2";
export var dataRow = "_lc-0";
export var headerRow = "_lc-1";